import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { Menu, X } from "lucide-react";
import logo from "../../assets/logo.svg";

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [
    { href: "/#solutions", text: "Solutions" },
    { href: "/#industries", text: "Industries" },
    { href: "/#platform", text: "Platform" },
    { href: "/#enterprise", text: "Enterprise" },
    { href: "/#pricing", text: "Pricing" },
    { href: "/#resources", text: "Resources" },
    { href: "/contact", text: "Contact" },
  ];

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-white/80 backdrop-blur-xl border-b border-green-100">
      <div className="w-full max-w-[1600px] mx-auto px-8 lg:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex flex-col items-center">
            <img src={logo} alt="Eaze" className="w-24 h-24 object-contain" />

            <div className="hidden sm:block">
              {/* <h1 className="text-xl font-bold text-gray-900">EAZE</h1> */}
{/* 
              <p className="text-xs text-gray-500 -mt-1">
                Africa's Business OS
              </p> */}
            </div>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-8 bg-white/70 border border-gray-200 rounded-full px-10 xl:px-12 py-3 shadow-lg">
            {navLinks.map((link) => (
              <a
                key={link.text}
                href={link.href}
                className="text-sm font-medium text-gray-700 hover:text-[#51BB55] transition"
              >
                {link.text}
              </a>
            ))}
          </nav>

          {/* Right Side */}
          <div className="hidden lg:flex items-center gap-3">
            {/* Badge */}
            {/* <div className="hidden xl:flex items-center rounded-full border border-green-200 bg-green-50 px-3 py-1">
              <span className="text-xs font-medium text-green-700">
                ERP • AI • Revenue Assurance
              </span>
            </div> */}

            <Link to="/login">
              <Button variant="ghost">Sign In</Button>
            </Link>

            <Link to="/book-demo">
              <Button
                variant="outline"
                className="border-[#51BB55] text-[#51BB55] hover:bg-green-50"
              >
                Book a demo
              </Button>
            </Link>

            <Link to="/register?trial=1">
              <Button className="bg-[#4CAF50] text-white hover:bg-[#45A049]">
                Start free trial
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="border rounded-xl"
            >
              {mobileMenuOpen ? <X size={22} /> : <Menu size={22} />}
            </Button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-white border-t shadow-xl">
          <div className="px-6 py-6 space-y-5">
            <div className="rounded-xl bg-green-50 border border-green-200 p-3">
              <p className="text-sm font-medium text-green-700">
                ERP • AI • Revenue Assurance
              </p>
            </div>

            {navLinks.map((link) => (
              <a
                key={link.text}
                href={link.href}
                className="block text-gray-700 font-medium hover:text-[#51BB55]"
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.text}
              </a>
            ))}

            <div className="border-t pt-4 space-y-3">
              <Link to="/login">
                <Button variant="outline" className="w-full">
                  Sign In
                </Button>
              </Link>

              <Link to="/book-demo">
                <Button
                  variant="outline"
                  className="w-full border-[#51BB55] text-[#51BB55]"
                >
                  Book a demo
                </Button>
              </Link>

              <Link to="/register?trial=1">
                <Button className="w-full bg-[#4CAF50] hover:bg-[#45A049]">
                  Start free trial
                </Button>
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
